import { connect } from "react-redux";
import { 
  fetchPerformanceInteractionsGraphReport, 
  fetchPerformanceLeadsGraphReport,
  fetchPerformanceDealsGraphReport, 
  fetchPerformanceDealValueGraphReport, 
  fetchPerformanceClosedDealsGraphReport,
  fetchPerformanceClosedDealValueGraphReport,

  fetchPerformanceTopContentGeneratingLeads,
  fetchPerformanceTopContentClosedDeals,

  fetchDealsDetailReport,
  fetchLeadsDetailReport,
  intializeDownloadReport
} from '../../../redux/actions/reports.jsx';

import { trackAdoptionMetricsForReportsToggledViewEvent } from "src/legacy/redux/actions/adoption.jsx";

import PerformanceReportView from "./view.jsx";

const mapStateToProps = (state, ownProps) => {
  return {
    download: state.legacyRootReducer.reports.download
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPerformanceInteractionsGraphReport: (filter) => {
      return dispatch(fetchPerformanceInteractionsGraphReport(filter));
    },
    fetchPerformanceLeadsGraphReport: (filter) => {
      return dispatch(fetchPerformanceLeadsGraphReport(filter));
    },
    fetchPerformanceDealsGraphReport: (filter) => {
      return dispatch(fetchPerformanceDealsGraphReport(filter));
    },
    fetchPerformanceDealValueGraphReport: (filter) => {
      return dispatch(fetchPerformanceDealValueGraphReport(filter));
    },
    fetchPerformanceClosedDealsGraphReport: (filter) => {
      return dispatch(fetchPerformanceClosedDealsGraphReport(filter));
    },
    fetchPerformanceClosedDealValueGraphReport: (filter) => {
      return dispatch(fetchPerformanceClosedDealValueGraphReport(filter));
    },

    fetchPerformanceTopContentGeneratingLeads: (filter, page, limit) => {
      return dispatch(fetchPerformanceTopContentGeneratingLeads(filter, page, limit));
    },

    fetchPerformanceTopContentClosedDeals: (filter, page, limit) => {
      return dispatch(fetchPerformanceTopContentClosedDeals(filter, page, limit));
    },

    fetchDealsDetailReport: (filter, page, limit) => {
      return dispatch(fetchDealsDetailReport(filter, page, limit));
    },

    fetchLeadsDetailReport: (filter, page, limit) => {
      return dispatch(fetchLeadsDetailReport(filter, page, limit));
    },

    downloadReport: (id, filter, page, limit) => {
      return dispatch(intializeDownloadReport(id, filter, page, limit));
    },
    
    trackAdoptionMetricsForReportsToggledViewEvent: (tabType) => {
      return dispatch(trackAdoptionMetricsForReportsToggledViewEvent(tabType))
    }
  };
};

const PerformanceReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceReportView);

export default PerformanceReport;